(() => {
  if (window.giftiliyaProductStandardLoaded) return;
  window.giftiliyaProductStandardLoaded = true;
  const findGoogle = () => document.querySelector('[id^="grp-entangle--root"]') || document.querySelector('[id*="rocket_google_reviews_app_block"]');
  const syncReviews = () => {
    const target = findGoogle();
    if (!target) return;
    const count = target.querySelector('a[href*="google.com/maps"]')?.textContent.match(/[\d,]+/);
    document.querySelectorAll('[data-gsp-reviews]').forEach(link => {
      link.href = '#' + target.id;
      const label = link.querySelector('[data-gsp-review-count]');
      if (!count || !label) return;
      const next = label.textContent.replace(/^[\d,]+/, Number(count[0].replace(/,/g, '')).toLocaleString('en-IN'));
      if (label.textContent !== next) label.textContent = next;
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-gsp-reviews]');
    if (!link) return;
    const target = findGoogle();
    if (!target) return;
    event.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    target.focus({preventScroll:true});
    history.replaceState(null, '', '#' + target.id);
  });
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; syncReviews(); });
  }).observe(document.documentElement, {subtree:true,childList:true});
  syncReviews();
})();
